let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("etT7C")).then(() => parcelRequire('3NE6B'));